import { PerformanceMarkers } from './common-enum';

class AppPerformanceTracker {
    private static instance: AppPerformanceTracker;

    private appStartTime: number;

    private constructor() {
        // Initialize with current time, but will be updated when info call starts
        performance.mark(PerformanceMarkers.APP_START_TIME, {
            startTime: performance.now(),
        });
        // Mark the initial app start time
        this.initializeInfoCallTracking();
    }

    private initializeInfoCallTracking() {
        // Track info call start time
        const observer = new PerformanceObserver(list => {
            list.getEntries().forEach(entry => {
                if (entry.name.includes('prism/preauth/info')) {
                    // Update app start time to when info call started
                    this.appStartTime = entry.startTime;
                    // Clear previous mark and set new one at info call start time
                    const resourceEntry = entry as PerformanceResourceTiming;
                    performance.clearMarks(PerformanceMarkers.APP_START_TIME);
                    performance.mark(PerformanceMarkers.APP_START_TIME, {
                        startTime: entry.startTime,
                    });
                    performance.mark(
                        PerformanceMarkers.INFO_CALL_REQUEST_STARTED,
                        {
                            startTime: resourceEntry.requestStart,
                        },
                    );
                    performance.mark(
                        PerformanceMarkers.INFO_CALL_RESPONSE_STARTED,
                        {
                            startTime: resourceEntry.responseStart,
                        },
                    );
                    performance.mark(
                        PerformanceMarkers.INFO_CALL_RESPONSE_ENDED,
                        {
                            startTime: resourceEntry.responseEnd,
                        },
                    );
                    observer.disconnect();
                }
            });
        });
        observer.observe({ entryTypes: ['resource'] });
    }

    public static getInstance(): AppPerformanceTracker {
        if (!AppPerformanceTracker.instance) {
            AppPerformanceTracker.instance = new AppPerformanceTracker();
        }
        return AppPerformanceTracker.instance;
    }

    public markAppMount() {
        performance.mark(PerformanceMarkers.APP_MOUNTED);
        const mountTime = Date.now() - this.appStartTime;
        return mountTime;
    }
}

export const appPerformanceTracker = AppPerformanceTracker.getInstance();
